import React, { createContext, useContext, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { scopes, msalInstance } from '../../authConfig';

interface AccessTokenContextProps {
  accessToken: string | null;
  setAccessToken: React.Dispatch<React.SetStateAction<string | null>>;
}

const AccessTokenContext = createContext<AccessTokenContextProps | undefined>(undefined);

export const AccessTokenProviderV2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { accounts } = useMsal();
  const [accessToken, setAccessToken] = useState<string | null>(() => {
    const savedAccessToken = localStorage.getItem('accessToken');
    return savedAccessToken !== null ? savedAccessToken : null;
  });

  useEffect(() => {
    const acquireAccessToken = async () => {
      try {
        if (accounts.length === 0) {
          throw new Error("No accounts available");
        }
        const response = await msalInstance.acquireTokenSilent({
          scopes: scopes,
          account: accounts[0],
        });
        setAccessToken(response.accessToken);
      } catch (error) {
        console.error("Error acquiring access token:", error);
      }
    };

    acquireAccessToken();
  }, [accounts]);

  useEffect(() => {
    if (accessToken !== null) {
      localStorage.setItem('accessToken', accessToken);
    } else {
      localStorage.removeItem('accessToken');
    }
  }, [accessToken]);

  return (
    <AccessTokenContext.Provider value={{ accessToken, setAccessToken }}>
      {children}
    </AccessTokenContext.Provider>
  );
};

export const useAccessToken = () => {
  const context = useContext(AccessTokenContext);
  if (!context) {
    throw new Error('useAccessToken must be used within an AccessTokenProvider');
  }
  return context;
};
